import React from 'react';

export const Footer = (props) => {
  return (
    <div id='footer'>
      <hr/>
    </div>
  )
}